import React from "react"
import { Row, Col, Form, Input, Flex } from "antd"
import { CardNumberElement, CardExpiryElement, CardCvcElement } from "@stripe/react-stripe-js"
import PropTypes from "prop-types"

const CardDetailsForm = ({ create, active, cardChangeHandler, isGuide }) => {
  return (
      <Row gutter={16} className={`mt-m w-1/2`}>
        <Col span={24}>
          <Form.Item label="Card Number *">
            {create ? (
              <Form.Item name="cardNumber" noStyle>
                <div className="stripe-input">
                  <CardNumberElement options={{ showIcon: true, disableLink: true }} onChange={cardChangeHandler} />
                </div>
              </Form.Item>
            ) : (
              <Input value={`**** **** **** ${active?.last4 || ""}`} disabled />
            )}
          </Form.Item>
        </Col>

        <Col span={24}>
          <Flex gap={16} justify="space-between" align="center" className="w-full">
            <Form.Item label="Expiry Date *" className="flex-1">
              {create ? (
                <Form.Item name="cardExpiry" noStyle>
                  <div className="stripe-input">
                    <CardExpiryElement onChange={cardChangeHandler} />
                  </div>
                </Form.Item>
              ) : (
                <Input
                  value={active?.exp_month && active?.exp_year ? `${active.exp_month}/${active.exp_year.toString().slice(-2)}` : ""}
                  disabled
                />
              )}
            </Form.Item>

            <Form.Item label="CVV *" className="flex-1">
              {create ? (
                <Form.Item name="cardCvc" noStyle>
                  <div className="stripe-input">
                    <CardCvcElement onChange={cardChangeHandler} />
                  </div>
                </Form.Item>
              ) : (
                <Input value="***" disabled />
              )}
            </Form.Item>
          </Flex>
        </Col>
      </Row>
  )
}

CardDetailsForm.propTypes = {
  create: PropTypes.bool.isRequired,
  active: PropTypes.object,
  cardChangeHandler: PropTypes.func.isRequired,
  isGuide: PropTypes.bool.isRequired
}

export default CardDetailsForm
